import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getClientsPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/portfolio",
		[Locale.en]: "/portfolio",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
